import styled from 'styled-components';
import { motion } from 'framer-motion';

const Layout = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-height: calc(100vh - 70px);
  flex-direction: column;
  background: ${(props) => props.theme.appLayout.layoutBackground};
  margin-top: 70px;
  width: 100%;
`;

export const LayoutContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 70px);
`;

const Main = styled.div`
  width: 100%;
  padding: 0 50px;
  margin: 0 auto;
  max-width: 100%;
  z-index: 1;

  background: ${({ theme }) => theme.colors.neutral50};
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
`;

const MainWrapper = styled.div`
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  @media (max-width: 1200px) {
    padding: 0 32px;
  }
`;

const MainNav = styled.div`
  max-width: 1687px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
`;

const TopNavigation = styled(motion.div)`
  width: 100%;
  background: ${(props) => props.theme.appLayout.navBackground};
  color: ${(props) => props.theme.appLayout.navFontColor};
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 50px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: ${(props) => props.theme.shadows.shadowXS};

  @media (max-width: 800px) {
    padding: 0 20px;
    z-index: 110;
  }

  a {
    color: ${(props) => props.theme.appLayout.navFontColor} !important;
  }
`;

const TopNavigationMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
`;

const Navigation = styled.div`
  width: 100%;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const FooterStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: 20px;
  flex-direction: column;
  color: ${(props) => props.theme.appLayout.footerFontColor} !important;

  > * {
    color: ${(props) => props.theme.appLayout.footerFontColor} !important;
  }

  a {
    color: ${(props) => props.theme.appLayout.footerFontColor} !important;
  }
  img {
    height: 24px;
  }
`;

export const FooterMobileStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 20px;
  img {
    width: 100px;
  }
`;

const SideButtons = styled(motion.div)`
  padding-top: 80px;
  width: 72px;
  background: ${(props) => props.theme.appLayout.sideNavBackground};
  position: fixed;
  top: 70px;
  left: 0;
  overflow: hidden;
  min-height: calc(100vh - 70px);
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  z-index: 98;

  img {
    margin: 20px;
    width: 32px;
  }

  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    display: none;
    opacity: 0;
  }

  button {
    opacity: 0;
  }

  :hover {
    width: 210px;
    p {
      opacity: 1;
      display: flex;
      flex: none;
    }
    button {
      opacity: 1;
    }
  }
  transition: all 0.2s ease;
  @media (max-width: 800px) {
    display: none;
  }
`;

const SideButtonsContent = styled.div`
  width: 100%;

  img {
    margin: 30px 20px;
  }
`;

export const Menu = styled.div<{ isOpen: boolean }>`
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  max-height: calc(100vh - 200px);
  background: ${(props) => props.theme.appLayout.navBackground};
  border-radius: 12px;
  padding: 24px;
  position: absolute;
  top: 60px;
  right: 0;
  width: 350px;
  font-size: 16px;
  line-height: 20px;
  overflow: auto;

  span {
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }

  /* ${(props) => (props.isOpen ? 'display: block;' : 'display: none;')}; */
  ${(props) => (props.isOpen ? 'visibility: visible;' : 'visibility: hidden;')}
  ${(props) => (props.isOpen ? 'opacity: 1;' : 'opacity: 0;')};
  transform: ${(props) =>
    props.isOpen ? ' translateY(0)' : 'translateY(-20px)'};

  transition: all 0.2s ease;

  z-index: 100005;
`;

export const MenuInviteLabels = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* color: #ffffff; */
  margin-bottom: 12px;
`;

export const MenuInvitePlaceholder = styled.div`
  background: ${(props) => props.theme.colors.neutral100};
  border-radius: 8px;
  min-height: 48px;
  width: 100%;
  padding: 12px;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 12px;
  justify-content: space-between;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.neutral900};
  word-break: break-all;
`;

export const Collapsable = styled.div<{ expanded: boolean }>`
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  max-height: ${(props) => (props.expanded ? '388px' : '0')};
  visibility: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  transition: all 0.3s ease;
`;

export const LanguageSelect = styled.select`
  background: none;
  color: ${(props) => props.theme.colors.neutral900} !important;
  border: none;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 22px;
  line-height: 32px;
  color: ${(props) => props.theme.dashboard.fontColor};
  margin-bottom: 24px;

  display: flex;
  align-items: center;
`;

export {
  Layout,
  Main,
  MainWrapper,
  TopNavigation,
  MainNav,
  Navigation,
  FooterStyled,
  TopNavigationMain,
  SideButtons,
  SideButtonsContent
};
